import { render, staticRenderFns } from "./Beeldweb.vue?vue&type=template&id=0daef928&scoped=true&"
import script from "./Beeldweb.vue?vue&type=script&lang=js&"
export * from "./Beeldweb.vue?vue&type=script&lang=js&"
import style0 from "./Beeldweb.vue?vue&type=style&index=0&id=0daef928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daef928",
  null
  
)

export default component.exports